<template>
  <b-table
      :fields="fields"
      :items="items"
      @row-clicked="onClickRow"
      table-class="text-nowrap"
      responsive
      hover
  >
    <template #cell(company_name)="data">
      <h4 class="mb-0">{{ data.item.company_name }}</h4>
    </template>
  </b-table>
</template>

<script>
import {convertFromUtc} from "../helpers";

export default {
  name: "AdminApplicationsTable",
  props: {
    applications: {
      type: Array,
      required: true
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fields: this.getTableFields()
    }
  },
  computed: {
    items() {
      return this.applications.map(application => ({
        application,
        company_name: application.name,
        owner: application.user.name,
        email: application.user.email,
        state: application.license.location.address_state,
        date_applied: convertFromUtc(application.created_at, 'L'),
        license: application.license.type.name + ' #' + application.license.number
      }))
    }
  },
  methods: {
    getTableFields() {
      if (this.small) {
        return [
          {
            key: "company_name",
            thClass: "border-top-0",
            tdClass: "align-middle cursor-pointer"
          },
          {
            key: "owner",
            thClass: "border-top-0",
            tdClass: "align-middle cursor-pointer"
          },
          {
            key: "license",
            thClass: "border-top-0",
            tdClass: "align-middle cursor-pointer"
          }
        ]
      }
      return [
        {
          key: "company_name",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "owner",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "email",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "state",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "license",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "date_applied",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        }
      ]
    },
    onClickRow(item) {
      let applicationId = item.application.id;
      this.$router.push({ name: "admin-application", params: { id: applicationId.toString() } });
    }
  }
}
</script>
